// extracted by mini-css-extract-plugin
module.exports = {"kodBlack":"#141a1d","kodWhitesmoke":"#eeeef1","kodGreen":"#0f9c5d","kodStandardBG":"#f8f8fb"};